import Backend from 'App/Dataman-Backend';

const { apiHost, apiFiles, apiUrlFilesGroups, apiUrlSuffix } = Backend.config;

export const FILES_PATHS = {
  host: apiHost,
  files: apiFiles,
  filesGroups: apiUrlFilesGroups,
  suffix: apiUrlSuffix,
};
